var map = {
	"./1-1-p4.svg": "8e7e",
	"./1-2-p4.svg": "40c1",
	"./1-3-p4.svg": "550b",
	"./1-4-p4.svg": "a1d9",
	"./1-5-p4.svg": "8318"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "668b";